import {VNode} from 'snabbdom';
import {jsx} from 'panel';

import {FilterValueProps} from 'common/query-builder/query-entry-section/row-types/filter/types';
import {PropertyType} from 'common/report/constants';
import {FilterBooleanValue} from 'common/query-builder/query-entry-section/row-types/filter/types/boolean';
import {FilterNumericValue} from 'common/query-builder/query-entry-section/row-types/filter/types/number';
import {FilterStringValue} from 'common/query-builder/query-entry-section/row-types/filter/types/string';
import {FilterObjectValue} from 'common/query-builder/query-entry-section/row-types/filter/types/object';
import {FilterListValue} from 'common/query-builder/query-entry-section/row-types/filter/types/list';
import {FilterDateValue} from 'common/query-builder/query-entry-section/row-types/filter/types/date';
// eslint-disable-next-line import/no-cycle -- a value component can import filter parts for recursive rendering
import {FilterListObjectValueEl} from 'common/query-builder/query-entry-section/row-types/filter/types/list/object';

type ValueTemplateType = (props: FilterValueProps) => VNode;

export const FilterValueTemplate: Record<PropertyType, ValueTemplateType> = {
  [PropertyType.Boolean]: FilterBooleanValue,
  [PropertyType.Number]: FilterNumericValue,
  [PropertyType.String]: FilterStringValue,
  [PropertyType.Object]: FilterObjectValue,
  [PropertyType.List]: FilterListValue,
  [PropertyType.Datetime]: FilterDateValue,
  // the following property type filters do not render a value definition
  [PropertyType.Dimension]: null,
  [PropertyType.NonProperty]: null,
  [PropertyType.Unknown]: null,
};

export const FilterListValueTemplate: Partial<Record<PropertyType, ValueTemplateType>> = {
  [PropertyType.Object]: (props) => <FilterListObjectValueEl params={props} />,
};
